import React from "react";
import Icon from "@mdi/react";
import { mdiMagnify } from "@mdi/js";
import "../../assets/styles/components/textfield.scss";
import { Select } from "antd";
import { Button, Checkbox, Form, Input } from "antd";

const { Option } = Select;

interface Props {
  placeholder?: string;
  color?: string;
  className?: string;
  onTypeChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  options?: any;
  defaultValue?: string;
}

// function handleChange(value: any) {
//   console.log(`selected ${value}`);
// }

const SearchCateField: React.FC<Props> = ({
  placeholder,
  onChange,
  onTypeChange,
  color = "#f4f4f4",
  className = "",
  options = [],
  defaultValue = "",
}) => {
  return (
    <div
      className={`search-field ${className}`}
      style={{ backgroundColor: color }}
    >
      {/* <Select
        style={{ width: 180, background: "transparent", padding: "0px 10px" }}
        onChange={onTypeChange}
        className="no-border"
      >
        {options.map((option: any, index: number) => (
          <Option value={option.value} key={index}>
            {option.label}
          </Option>
        ))}
      </Select> */}
      <Form
        name="basic"
        // labelCol={{ span: 8 }}
        // wrapperCol={{ span: 16 }}
        initialValues={{ selectType: defaultValue }}
      >
        <Form.Item
          name="selectType"
          // rules={[{ required: true, message: "Please input your password!" }]}
        >
          <Select
            style={{
              width: 180,
              background: "transparent",
              padding: "0px 10px",
            }}
            onChange={onTypeChange}
            className="no-border"
          >
            {options.map((option: any, index: number) => (
              <Option value={option.value} key={index}>
                {option.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
      <input type="text" placeholder={placeholder} onChange={onChange} />
      <span>
        <Icon path={mdiMagnify} size="30" color="#5BAEA9" />
      </span>
    </div>
  );
};

export default SearchCateField;
